var $name="gsapAnimation",$path="configs/gsapAnimation.js",$this={$name,$path,};module.exports = {
  // according to the https://www.researchgate.net average swipe distance on mobile is 18% from screen width
  recognitionRate: 0.18,
  // delay for auto select to a next slide, seconds
  slideDelay: 10,
  // duration for slide animation, seconds
  slideDuration: 0.3,
};
